// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"cc991ab8","213":"67537418","239":"be0d2136","453":"8bd102f6","455":"1260348c"}[chunkId] + ".chunk.js";
};